import Api from '../http.service';

export const getPopularAirport = () => Api.GET({ url: 'location/popular' });

/**get all location
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.sort
 * @param {Object} payload.data.filter
 * @param {String} payload.data.filter.phrase
 * @param {String} payload.data.filter.countryCode
 * @param {String} payload.data.filter.type
 */
export const getAll = (payload) =>
  Api.POST({
    url: `location/all/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });

/**get country location
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.countryCode
 */
export const getCountry = (payload) =>
  Api.POST({
    url: `location/country/`,
    data: payload.data,
  });
